import React, { Component } from 'react'
import Typography from '@material-ui/core/Typography'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLongArrowAltLeft } from '@fortawesome/free-solid-svg-icons'
import CircularProgress from '@material-ui/core/CircularProgress'

import Input from '../../common/Input'
import { Button } from '../../common'

import * as Constants from '../../../helpers/Constants'
import * as Strings from './strings'
import * as Styles from './styles'
import * as userActions from '../../actions/User'
import * as configActions from '../../actions/Config'

class Login extends Component {
  constructor(props) {
    super(props)
    this.state = {
      emailInput: '',
      passwordInput: ''
    }
    this.enterHandler = this.enterHandler.bind(this)
  }

  componentWillMount() {
    window.addEventListener('keypress', this.enterHandler)
    this.props.tryValidateUser()
  }

  componentWillUnmount() {
    window.removeEventListener('keypress', this.enterHandler)
  }

  enterHandler(e) {
    if (e.charCode === 13) {
      this.signIn()
    }
  }

  signIn() {
    const { emailInput, passwordInput } = this.state

    if (emailInput === '' || passwordInput === '') {
      this.props.showAlert(
        Strings.default.MISSING_FIELDS_HEADER,
        Strings.default.MISSING_FIELDS,
        Constants.ONE_BUTTON,
        { title: Strings.default.OK, onPress: () => {} }
      )
    } else {
      const data = { email: emailInput, password: passwordInput }

      this.props.trySignIn(data, (header, fields, button) => {
        this.props.showAlert(header, fields, Constants.ONE_BUTTON, button)
      })
    }
  }

  render() {
    const { emailInput, passwordInput } = this.state
    const { history, user, data } = this.props

    if (user.token) {
      history.push('/dashboard')
    }

    return (
      <div className={'basicCentered'}>
        <div className={'basicContainer'}>
          {user.isValidatingToken || user.isFetchingDataWithToken ? (
            <CircularProgress
              style={{ color: '#3b424d' }}
              thickness={2}
              size={75}
            />
          ) : (
            <div style={{ width: 350 }}>
              <Typography variant="display1" gutterBottom>
                {Strings.default.SIGN_IN}
              </Typography>
              <Input
                placeholder={Strings.default.EMAIL_ADDRESS}
                value={emailInput}
                onChange={value => this.setState({ emailInput: value })}
              />
              <Input
                placeholder={Strings.default.PASSWORD}
                type={'password'}
                value={passwordInput}
                onChange={value => this.setState({ passwordInput: value })}
              />
              <Button
                onClick={() => this.signIn()}
                header={Strings.default.SIGN_IN}
                loading={user.isSigningIn || data.isFetching}
              />
            </div>
          )}
        </div>
      </div>
    )
  }
}

function mapStateToProps({ user, data }) {
  return { user, data }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...userActions, ...configActions }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)



// WEBPACK FOOTER //
// ./src/components/pages/Login/index.js